// src/lib/events.ts
export type Event = {
  name: string;
  properties?: Record<string, any>;
};

export function trackEvent(event: Event) {
  console.log("Tracking event:", event);
}
